import type { ReactNode } from 'react';
import type { Drone } from '@tonist/shared';
import { FamilyDot } from './FamilyDot';

export function DroneCard({ drone, meta, actions, preview }: { drone: Drone; meta?: ReactNode; actions?: ReactNode; preview?: { playing: boolean; onToggle: () => void } }) {
  return (
    <article className="glass card" aria-label={drone.name}>
      <div className="card__title">
        <FamilyDot family={drone.family} />
        <span className="grow">{drone.name}</span>
        {preview && (
          <button type="button" className={`btn btn--sm btn--ghost preview-btn${preview.playing ? ' is-playing' : ''}`} aria-pressed={preview.playing}
            title={drone.sources[0]?.kind === 'sample' ? 'Play the original sample' : 'Play this drone at Sa'} aria-label={`${preview.playing ? 'Stop' : 'Play'} ${drone.name}`}
            onClick={preview.onToggle}>{preview.playing ? '■' : '▶'}</button>
        )}
      </div>
      <div className="card__desc">{drone.description || sourcesSummary(drone)}</div>
      {meta && <div className="card__meta">{meta}</div>}
      {actions && <div className="card__actions">{actions}</div>}
    </article>
  );
}

export function sourcesSummary(d: Drone): string {
  return d.sources.map((s) => (s.kind === 'synth' ? `${s.engine} synth` : `${s.kind}: ${s.sampleId}`)).join(' + ');
}
